import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import Image from "../../../../../base/multimedia/image/index.js";
import { genKey } from "../../../../../../helpers/keys.js";
import Points from "../points/index.js";
import * as S from "./styled.js";
export const MapImage = ({ props , language  })=>{
    const [hover, setHover] = useState('');
    const { items =[] , map  } = props ?? {};
    return /*#__PURE__*/ _jsxs(S.ListMap, {
        children: [
            /*#__PURE__*/ _jsx(S.Content, {
                children: items.map((item)=>/*#__PURE__*/ _jsxs(S.Group, {
                        children: [
                            /*#__PURE__*/ _jsx(S.Title, {
                                children: item.title
                            }),
                            /*#__PURE__*/ _jsx(S.ColumnList, {
                                children: item.items.map((i)=>/*#__PURE__*/ _jsx(React.Fragment, {
                                        children: /*#__PURE__*/ _jsx(S.ColumnItem, {
                                            children: /*#__PURE__*/ _jsx(S.Link, {
                                                onMouseEnter: ()=>setHover(i.id),
                                                onMouseLeave: ()=>setHover(''),
                                                href: i.href,
                                                children: i.title
                                            })
                                        }, genKey(i.id))
                                    }, genKey(i.id)))
                            })
                        ]
                    }, genKey(item.title)))
            }),
            language && /*#__PURE__*/ _jsxs(S.MapCoasts, {
                $language: language,
                children: [
                    map && /*#__PURE__*/ _jsx(Image, {
                        src: map?.src,
                        alt: map?.alt
                    }),
                    /*#__PURE__*/ _jsx(Points, {
                        hover: hover,
                        props: props
                    })
                ]
            })
        ]
    });
};
export default MapImage;

//# sourceMappingURL=index.js.map